import PropTypes from 'prop-types';

import { IconPoll } from '../../../Components/Common/Icons';
import { getPollMessagePreview } from '../pollText';
import styles from './index.module.scss';

// Recent chats may carry meta_data as the raw JSON string the server stored.
const readMeta = metaData => {
    if (metaData && typeof metaData === 'object') return metaData;
    try {
        return metaData ? JSON.parse(metaData) : {};
    } catch {
        return {};
    }
};

// An older message may have left another poll's activity on the row.
const metaOfPoll = (meta, poll) => (meta.pollId && poll?.pollId && meta.pollId !== poll.pollId ? {} : meta);

/**
 * Chat list preview of a group whose last message is a poll:
 * "You created a poll: {Question}", or the latest activity, such as "Alpha voted in the poll".
 *
 * @param {object} recent Recent chat row: msgBody, metaData, publisherId.
 */
const PollPreview = ({ recent }) => {
    const { msgBody = {}, metaData, publisherId } = recent;
    const meta = metaOfPoll(readMeta(metaData), msgBody.poll);
    const text = getPollMessagePreview({ ...meta, poll: msgBody.poll, publisherId });

    // preview-media keeps the layout of the other media previews of the chat list.
    return (
        <div className={`preview-media ${styles.preview}`}>
            <i className="chat-poll">
                <IconPoll />
            </i>
            <p>{text}</p>
        </div>
    );
};

PollPreview.propTypes = {
    recent: PropTypes.shape({
        msgBody: PropTypes.object,
        metaData: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        publisherId: PropTypes.string,
    }).isRequired,
};

export default PollPreview;
